import React, {Component} from 'react'
import {Col, Row} from "react-bootstrap";
import * as PropTypes from "prop-types";
import MainCard, {DateTimeDetails, RowInformation, TeamsLogo} from "./MainCard";

/**
 * The component that displays upcoming matches.
 */
class UpcomingMatches extends MainCard {

    /**
     * Render UpcomingMatches components from data object.
     * @returns {React.ReactNode} The UpcomingMatches components.
     */
    renderItemsFromData = () => {
        const {data} = this.props;
        return data.map((rowData, index) =>
            <UpcomingMatchesRow
                key={index}
                title={rowData.title} subtitle1={rowData.subtitle1} subtitle2={rowData.subtitle2} date={rowData.date} time={rowData.time}
                avatar1={rowData.avatar1} avatar2={rowData.avatar2} badge={rowData.badge}/>
        );
    };

    static propTypes = {
        // The text that will appear in the Header.
        title: PropTypes.string.isRequired,
    };
    static defaultProps = {
        title: "Upcoming Matches",
        footerText: "All Matches",
        footerLink: "#"
    };
}

/**
 * The row component of UpcomingMatches.
 */
class UpcomingMatchesRow extends Component {
    render = () => {
        // TODO: Set values form props.
        const {avatar1, avatar2, title, subtitle1, subtitle2, datetime, datetimeType, badge} = this.props;
        return (
            <Row className="card-row">
                <Col sm="auto" className="p-0">
                    <TeamsLogo team1={avatar1} team2={avatar2} badge={badge}/>
                </Col>

                <Col className="p-0">
                    <RowInformation title={title} subtitle={subtitle1} description={subtitle2}/>
                </Col>

                <Col sm="auto" className="p-0">
                    <DateTimeDetails datetime={datetime} datetimeType={datetimeType}/>
                </Col>
            </Row>
        );
    };


    static propTypes = {
        // The text that will appear in the first line.
        title: PropTypes.string.isRequired,
        // The text that will appear in the second line.
        subtitle1: PropTypes.string.isRequired,
        // The text that will appear in the third line.
        subtitle2: PropTypes.string.isRequired,
        // The date value that will appear in the right side.
        date: PropTypes.string.isRequired,
        // The time value that will appear in the right side.
        time: PropTypes.string.isRequired,
        // The first team logo.
        avatar1: PropTypes.string.isRequired,
        // The second team logo.
        avatar2: PropTypes.string.isRequired,
        // The badge displays on the top left corner.
        badge: PropTypes.bool,
    };
}

export {UpcomingMatches, UpcomingMatchesRow}
